import axios from '@/config/axios'

const baseUrl = "/v1/api/mg/p/company";

export const company =(query) => axios.get(`${baseUrl}`,{params: query})


export const listCompanyByType = (type) => axios.get(`${baseUrl}?type=${type}`)


export const saveCompany = (company) => axios.post(`${baseUrl}`, company)

export const updatedCompany = (company) => axios.put(`${baseUrl}/${company.id}`, company)

export const deleteCompany = (company) => axios.delete(`${baseUrl}/${company.id}`, company)

